import { Granularity } from '@/components/kol/common/time-granularity-selector'

export const GRANULARITY_CHART_WIDTH_MAP: Record<Granularity, string> = {
  day: '3800px',
  week: '1100px',
  month: '100%',
}
export type SeriesData = { x: string; y: number; totalAmount: number }

export type Series = {
  name: string
  color: string
  data: SeriesData[]
}
